import { tryFetch, HttpMethod, type ErrorResponse } from '@/services/http'
import type { CacheSectionUpdate } from '../models/cache.model'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const checkStatus = async (
  body: string
): Promise<{ data?: CacheSectionUpdate; error?: ErrorResponse<any>; status: number }> =>
  await tryFetch(HttpMethod.Post, BASE_URL, 'cache/check-status', { view: true, body })

export const cacheApi = {
  checkStatus,
}
